//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PickleBanner from '@vanishing/components/PickleBanner'

import ProductAd from './ProductAd'
import ProductCard from './ProductCard'

export default {
  components: {
    PickleBanner,
    ProductCard,
    ProductAd,
  },
  props: {
    recommendations: {
      type: Array,
      required: true,
    },
    searchResults: {
      type: Array,
      required: true,
    },
    wide: { type: Boolean, default: false },
    showFaq: { type: Boolean, default: false },
    showBuyingGuide: { type: Boolean, default: false },
    showPaymentMethodAdvertising: { type: Boolean, default: false },
    showBanner: { type: Boolean, default: false },
    showRecommendations: { type: Boolean, default: true },
  },
}
